export const ColorShadePositions = {
  LIGHTER: 'LIGHTER',
  LIGHT: 'LIGHT',
  MEDIUM: 'MEDIUM',
  DARK: 'DARK',
  DARKER: 'DARKER'
};
export const SHADE_POSITION_NAMES = Object.values(ColorShadePositions);